import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';

import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxProgramme } from '../ComboBox/ComboBoxProgramme';
import { ComboBoxTrancheTravaux } from '../ComboBox/ComboBoxTrancheTravaux';
import { ComboBoxProduit } from '../ComboBox/ComboBoxProduit';
import { ComboBoxSousProduit } from '../ComboBox/ComboBoxSousProduit';
import { ComboBoxTypeVente } from '../ComboBox/ComboBoxTypeVente';
import { ComboBoxTypeContrat } from '../ComboBox/ComboBoxTypeContrat';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import './FicheIdentification.css';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataOperation } from '../../data/DataOperation';
import { DataTypeProgramme } from '../../data/DataTypeProgramme';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelIdentificationNomenclature : bool
    onAffichageSansPanel : bool

    onEnregistrementFiche : méthode
    onFermeFicheIdentificationNomenclature : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    operation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    peutModifierPerimetre: false,
    peutModifierPrgTT: false,

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheIdentificationNomenclature extends Component {
    _creationContent() {
        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divRegion">
                        <ComboBoxRegion
                            disabled={!this.props.onAffichageSansPanel && !this.state.peutModifierPerimetre}
                            filtreSurMonPerimetre
                            onChange={(event, option, index, value, item) => this._onMiseAJourChamp("operation", "idRegion", option.key)}
                            required
                            selectedKey={this.state.operation.idRegion}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divAgence">
                        <ComboBoxAgence
                            disabled={!this.props.onAffichageSansPanel && !this.state.peutModifierPerimetre}
                            filtreSurMonPerimetre
                            idRegion={this.state.operation.idRegion}
                            onChange={(event, option, index, value, item) => this._onMiseAJourChamp("operation", "idAgence", option.key)}
                            required
                            selectedKey={this.state.operation.idAgence}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divProgramme">
                        <ComboBoxProgramme
                            disabled={!this.props.onAffichageSansPanel ? (this.state.peutModifierPrgTT ? !(this.state.operation.idRegion > 0 && this.state.operation.idAgence > 0) : true) : false}
                            idAgence={this.state.operation.idAgence}
                            idRegion={this.state.operation.idRegion}
                            onChange={(event, option, index, value, item) => this._onMiseAJourChamp("operation", "idProgramme", option.key)}
                            required
                            selectedKey={this.state.operation.idProgramme}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12" name="divTrancheTravaux">
                        <ComboBoxTrancheTravaux
                            disabled={!this.props.onAffichageSansPanel ? (this.state.peutModifierPrgTT ? !(this.state.operation.idRegion > 0 && this.state.operation.idAgence > 0 && this.state.operation.idProgramme > 0) : true) : false}
                            idProgramme={this.state.operation.idProgramme}
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "idTrancheTravaux", option.key)}
                            required
                            selectedKey={this.state.operation.idTrancheTravaux}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6" name="divProduit">
                        <ComboBoxProduit
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "idProduit", option.key)}
                            required
                            selectedKey={this.state.operation.idProduit}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6" name="divSousProduit">
                        <ComboBoxSousProduit
                            idProduit={this.state.operation.idProduit}
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "idSousProduit", option.key)}
                            required
                            selectedKey={this.state.operation.idSousProduit}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divTypeVente">
                        <ComboBoxTypeVente
                            idProduit={this.state.operation.idProduit}
                            idSousProduit={this.state.operation.idSousProduit}
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "idTypeVente", option.key)}
                            selectedKey={this.state.operation.idTypeVente}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divTypeContrat">
                        <ComboBoxTypeContrat
                            onChange={(event, option) => this._onMiseAJourChamp("operation", "idTypeContrat", option.key)}
                            selectedKey={this.state.operation.idTypeContrat}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        if (this.state.operation.idOperation === undefined) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement de l\'opération en cours'
            });

            var chargementFicheIdentificationNomenclature = DataOperation._chargementFicheIdentification();

            chargementFicheIdentificationNomenclature.then(
                responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let retourData = responseFetch.reponseAPIobjet;
                        let operation = retourData[0];
                        let stateTemp = {};
                        stateTemp.operation = operation;
                        stateTemp.peutModifierPerimetre = retourData[27];
                        stateTemp.peutModifierPrgTT = retourData[28];
                        stateTemp.titrePanel = 'Modifier l\'opération';
                        stateTemp.listOperationTVACas = this.props.listTva;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'opération en cours'
        });

        let enregistrementOperation = DataOperation._onEnregistrementOperation(this.state.operation, this.state.listOperationTVACas);

        enregistrementOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheIdentificationNomenclature();
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onRenderFooterContent = () => {
        let boutonActif = !this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <PrimaryButton name="btnEnregistrerNomenclature" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        if (nomPropriete == "idRegion") {
            let nomProprietes = [
                ["idRegion", valeur],
                ["idAgence", null],
                ["idProgramme", null],
                ["idTrancheTravaux", null]

            ];

            Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);

            if (this.state.operation.idRegion !== valeur) {
                this.setState({ hideMessageBarWarning: false, warningMessage: 'Attention, la modification du périmètre de l\'opération entraîne la modification des mandats et souhaits associés. La mise à jour peut prendre un certain temps.' });
            }
        }
        else if (nomPropriete == "idAgence") {
            let nomProprietes = [
                ["idAgence", valeur],
                ["idProgramme", null],
                ["idTrancheTravaux", null]

            ];

            Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);

            if (this.state.operation.idAgence !== valeur) {
                this.setState({ hideMessageBarWarning: false, warningMessage: 'Attention, la modification du périmètre de l\'opération entraîne la modification des mandats et souhaits associés. La mise à jour peut prendre en certain temps.' });
            }
        }
        else if (nomPropriete == "idProduit") {
            var getTypeProgramme = DataTypeProgramme._getTypeProgramme(valeur);
            getTypeProgramme.then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let nomProprietes = [];
                    let retourData = responseFetch.reponseAPIobjet;

                    if (retourData !== null) {
                        let typeProgrammeTrav = retourData;
                        nomProprietes = [
                            ["idProduit", valeur],
                            ["idSousProduit", 0],
                            ["idTypeProgramme", typeProgrammeTrav.idTypeProgramme]
                        ];
                    }
                    else {
                        nomProprietes = [
                            ["idProduit", valeur],
                            ["idSousProduit", 0],
                            ["idTypeProgramme", null]
                        ];
                    }

                    Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);

                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
        }
        else if (nomPropriete == "idProgramme") {
            let nomProprietes = [
                ["idProgramme", valeur],
                ["idTrancheTravaux", null]
            ];

            Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);
        }
        else {
            Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
        }

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'NomenclatureOperation', this.state.operation, (this.state.operation.idOperation > 0 ? 'Modification' : 'Création'));
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return (
                <Panel
                    isOpen={this.props.onAffichePanelIdentificationNomenclature}
                    headerText="Nomenclature"
                    type={PanelType.medium}
                    onDismiss={() => this._onAnnulation()}
                    onOpen={() => this._onOpen()}
                    closeButtonAriaLabel="Fermer"
                    onRenderFooterContent={this._onRenderFooterContent}
                >
                    <div className={this.props.classname}>
                        <div className={this.props.classnameinner}>
                            <div className="ms-Grid" dir="ltr">
                                <MessageBars
                                    errorMessage={this.state.errorMessage}
                                    warningMessage={this.state.warningMessage}
                                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                                />

                                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                                {content}
                            </div>
                        </div>
                    </div>
                </Panel>
            );
        }
    }
}